/**
* Nom : treatmentParamNew.js
* Description : Ce fichier contient la définition de la page treatmentParamNew 
*               Cette page fourni un formulaire pour créer un traitement disponible sur un produit client
* Date de création : 19 mars 2025
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { CompanyBar } from 'package_ui_ihm/dist'
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { SelectForm} from 'package_ui_ihm/dist'
import { InputForm } from 'package_ui_ihm/dist'
import TableMui from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useData } from 'package_ui_ihm/dist';
import { useNavigate } from 'react-router-dom'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* TreatmentParamNew : affiche une page avec un formulaire pour créer un traitement disponible sur un produit client
*                     un lien permet de revenir sur la page qui liste tous les traitements disponibles sur le produit client
*
* Type : page 
*
* Parametres : 
*  None
*/
function TreatmentParamNew() {

    //Define useParam
    const { equipmentId } = useParams()
    
    
    // Define useState hooks
    const [equipment, setEquipment] = useState(null);
    const [name, setName] = useState('');
    const [selectedCat, setSelectedCat] = useState(0);
    const [selectedVar, setSelectedVar] = useState(0);
    const [selectedTargetType, setSelectedTargetType] = useState(0);
    const [selectedTreatmentType, setSelectedTreatmentType] = useState(0);
    const [selectedEquipment, setSelectedEquipment] = useState(0);
    const [nbGroupes, setNbGroupes] = useState(1);
    const [description, setDescription] = useState(null);
    const [distance, setDistance] = useState(0)
    const [prevCat, setPrevCat] = useState(0);
    const [categories, setCategories] = useState([])
    const [varieties, setVarieties] = useState([])
    const [treatmentTypes, setTreatmentTypes] = useState([])
    const [filteredVarieties, setFilteredVarieties] = useState(varieties);
    const [treatment, setTreatment] = useState(null)
    const [statusTreatmentParam, setStatusTreatmentParam] = useState(null)
    const [statusModuleParams, setStatusModuleParams] = useState(null)
    const [nameError, setNameError] = useState(false);
    const [categoryError, setCategoryError] = useState(false);
    const [varietyError, setVarietyError] = useState(false);
    const [targetTypeError, setTargetTypeError] = useState(false);
    const [treatmentTypeError, setTreatmentTypeError] = useState(false);
    const [equipmentError, setEquipmentError] = useState(false);
    const [nbGroupesError, setNbGroupesError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);
    const [distanceError, setDistanceError] = useState(false);
    const [quart1, setQuart1] = useState(true);
    const [quart2, setQuart2] = useState(true);
    const [quart3, setQuart3] = useState(true);
    const [quart4, setQuart4] = useState(true);
    const [treatmentParamAdd, setTreatmentParamAdd] = useState(false)
    const [moduleParams, setModuleParams] = useState([])
    const [newFrequence, setNewFrequence] = useState(0)
    const [newPulseWidth, setNewPulseWidth] = useState(0)
    const [numberGroups, setNumberGroups] = useState(1);
    const [ptus, setPtus] = useState([])
    const [isDataLoading, setDataLoading] = useState(false)
    const [formSubmit, setFormSubmit] = useState(false);
    const [skipPrompt, setSkipPrompt] = useState(false);

    // Define useContext hooks
    const { authStatus, authToken } = useAuth();
    const { path } = useApi();
    const { targetTypes } = useData();

    const navigate = useNavigate();


    // Define useBlocker hooks
    const shouldBlock = 
        ((selectedCat !== "0" && selectedCat !== 0) ||
        (selectedVar !== "0" && selectedVar !== 0) ||
        (selectedTargetType !== "0" && selectedTargetType !== 0) ||
        (selectedTreatmentType !== "0" && selectedTreatmentType !== 0) ||
        (description !== null) || 
        (distance !== 0) || 
        (treatmentParamAdd === true)) && 
        (skipPrompt === false);
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(name, equipment_id, nb_groupes, category_id, variety_id, target_type_id, treatment_type_id, description, distance) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("name", name);
        form_data.append("equipment_id", Number(equipment_id));
        form_data.append("time_max_phase", -1);
        form_data.append("time_max_treatment", -1);
        form_data.append("nb_repeat_phase", 1);
        form_data.append("time_inter_phase", -1);
        form_data.append("nb_groupes", Number(nb_groupes));
        form_data.append("category_id", Number(category_id));
        form_data.append("variety_id", Number(variety_id));
        form_data.append("target_type_id", Number(target_type_id));
        form_data.append("treatment_type_id", Number(treatment_type_id));
        form_data.append("description", description);
        form_data.append("distance", distance);
        // Create Treatment Param
        const response = await fetch(path + "/api/eq-trpa/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        const data = await response.json();
        setStatusTreatmentParam(response["status"])
        setTreatment(data)
    }

    async function sendDataModuleParam(frequence, pulse_width, treatment_param_id, number_groupe, module_id) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("frequence", frequence);
        form_data.append("pulse_width", pulse_width);
        form_data.append("time_working", -1);
        form_data.append("treatment_param_id", treatment_param_id);
        form_data.append("delay", 0);
        form_data.append("temperature_max", 35);
        form_data.append("number_groupe", number_groupe);
        form_data.append("module_id", module_id);
        // Retrieve target details
        const response = await fetch(path + "/api/eq-mopa/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusModuleParams(response["status"])
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setSkipPrompt(true);
        if(name === null || name === ''){
            setNameError(true)
        }
        else
        {   
            setNameError(false)
        }
        if(selectedEquipment === 0 || selectedEquipment === '0'){
            setEquipmentError(true)
        }
        else
        {   
            setEquipmentError(false)
        }
        if(selectedCat === 0 || selectedCat === '0'){
            setCategoryError(true)
        }
        else
        {   
            setCategoryError(false)
        }
        if(selectedVar === 0 || selectedVar === '0'){
            setVarietyError(true)
        }
        else
        {   
            setVarietyError(false)
        }
        if(selectedTargetType === 0 || selectedTargetType === '0'){
            setTargetTypeError(true)
        }
        else
        {   
            setTargetTypeError(false)
        }
        if(selectedTreatmentType === 0 || selectedTreatmentType === '0'){
            setTreatmentTypeError(true)
        }
        else
        {   
            setTreatmentTypeError(false)
        }
        if(nbGroupes === null){
            setNbGroupesError(true)
        }
        else
        {   
            setNbGroupesError(false)
        }
        if(description === null){
            setDescriptionError(true)
        }
        else
        {   
            setDescriptionError(false)
        }
        if(distance === 0){
            setDistanceError(true)
        }
        else
        {   
            setDistanceError(false)
        }
        setFormSubmit(true)
    };

    function updateFilteredVarieties() {
        // Check category change to reinit variety
        if(selectedCat !== prevCat)
        {
            setSelectedVar(0);
            setPrevCat(selectedCat);
        }
        // Filtering of varieties
        if( selectedCat > 0 )
        {
            setFilteredVarieties(varieties.filter((variety) => variety.category_id === Number(selectedCat)))
        }  
        else
        {
            setFilteredVarieties(varieties)
        }
    }

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resEquipment, resCategory, resVariety, resTreatmentType, resPtu] = await Promise.all([
            // Equipment
            fetch(path + "/api/eq-eqnt/" + equipmentId + "/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Categories
            fetch(path + "/api/bo-cary/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Varieties
            fetch(path + "/api/bo-vaty/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Treatment types
            fetch(path + "/api/bo-trty/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Ptus
            fetch(path + "/api/eq-mole/?equipment_id=" + equipmentId, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataEquipment, dataCategory, dataVariety, dataTreatmentType, dataPtu] = await Promise.all([
            resEquipment.json(),
            resCategory.json(),
            resVariety.json(),
            resTreatmentType.json(),
            resPtu.json(),
        ])
        // Set variables
        setEquipment(dataEquipment)
        setCategories(dataCategory["results"])
        setVarieties(dataVariety["results"])
        setTreatmentTypes(dataTreatmentType["results"])
        setPtus(dataPtu["results"])
        // Dataloading
        setDataLoading(false)
    }

    const handleChangeQuart1 = (event) => {
        setQuart1(event.target.checked);
    };

    const handleChangeQuart2 = (event) => {
        setQuart2(event.target.checked);
    };

    const handleChangeQuart3 = (event) => {
        setQuart3(event.target.checked);
    };

    const handleChangeQuart4 = (event) => {
        setQuart4(event.target.checked);
    };

    const handleClickTreatmentParamAdd = (event) => {
        event.preventDefault();
        if(treatmentParamAdd === false) {
          setTreatmentParamAdd(true)
        } else {
          setTreatmentParamAdd(false)
        }
    };

    const handleSubmitPtu = (event) => {
        event.preventDefault();
        var ptu_id = 0
        ptus.forEach(ptu => {
            if(moduleParams.length + 1 === ptu["port"]){
                ptu_id = ptu["id"]
            }
        })
        var newModuleParam = {"ptu": moduleParams.length + 1, "frequence": newFrequence, "pulse_width": newPulseWidth, "module_id": ptu_id}
        moduleParams.push(newModuleParam)
        setModuleParams(moduleParams)
        setNewFrequence(0)
        setNewPulseWidth(0)
        setTreatmentParamAdd(false)
    };

    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            if(equipmentId !== undefined){
                setSelectedEquipment(equipmentId)
            }
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        updateFilteredVarieties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCat])

    useEffect(() => {
        var catName = ''
        var varName = ''
        var targetTypeName = ''
        var treatmentTypeName = ''
        if(categories.length !== 0 && Number(selectedCat) > 0)
        {
            catName = (categories.find((cat) => cat['id'] === Number(selectedCat)))['name']
        }
        if(filteredVarieties.length !== 0 && Number(selectedVar) > 0)
        {
            varName = (varieties.find((variety) => variety['id'] === Number(selectedVar)))['name']
        }
        if(targetTypes.length !== 0 && Number(selectedTargetType) > 0)
        {
            targetTypeName = (targetTypes.find((type) => type['id'] === Number(selectedTargetType)))['name']
        }
        if(treatmentTypes.length !== 0 && Number(selectedTreatmentType) > 0)
        {
            treatmentTypeName = (treatmentTypes.find((type) => type['id'] === Number(selectedTreatmentType)))['name']
        }
        setName(catName + ' ' + varName + ' ' + targetTypeName + ' ' + treatmentTypeName)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCat, selectedVar, selectedTargetType, selectedTreatmentType])
    
    useEffect(() => {
        if(formSubmit === true && nameError === false && equipmentError === false && categoryError === false && varietyError === false && targetTypeError === false && treatmentTypeError === false && nbGroupesError === false && descriptionError === false && distanceError === false){
            sendData(name, selectedEquipment, nbGroupes, selectedCat, selectedVar, selectedTargetType, selectedTreatmentType, description, distance)
        } else {
            setSkipPrompt(false);
            setFormSubmit(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formSubmit])

    useEffect(() => {
        if(statusTreatmentParam === 201) {
            moduleParams.forEach(moduleParam => {
                if(statusModuleParams === null || statusModuleParams === 201)
                {
                    sendDataModuleParam(moduleParam["frequence"], moduleParam["pulse_width"], treatment["id"], numberGroups, moduleParam["module_id"])
                }
            })
        } else {
            setFormSubmit(false)
            const treatment_path = '/treatment-params/new/' + equipmentId
            navigate(treatment_path)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusTreatmentParam, navigate]);

    useEffect(() => {
        if(statusModuleParams === 201) {
            const treatment_path = '/treatment-params/' + equipmentId
            navigate(treatment_path)
        } else {
            setFormSubmit(false)
            const treatment_path = '/treatment-params/new/' + equipmentId
            navigate(treatment_path)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusModuleParams, navigate]);

    useEffect(() => {
        setNbGroupes(Number(quart1) +  Number(quart2) + Number(quart3) +  Number(quart4))
        setNumberGroups(Number(quart1) +  Number(quart2) * 2 + Number(quart3) * 4 +  Number(quart4) * 8)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quart1, quart2, quart3, quart4])

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
            if (shouldBlock === true) {
                // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
                e.preventDefault();
                e.returnValue = "";
                // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
                return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
            }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <CompanyBar name_app="BOXIBRAIN"/>
            <TabC tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <div><p>Chargement des données</p></div>
                    ) : (
                        (equipment !== null) ? (
                            <div>
                                <h1>Créer un nouveau traitement</h1>
                                {/*Liens*/}
                                <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                                    <div className='link-border'>
                                        <BackPage path={'/treatment-params/' + equipmentId}>Retour à la liste des traitements disponibles</BackPage>
                                    </div>
                                </div>
                                {(statusTreatmentParam !== null && statusTreatmentParam !== 201 && nameError === false && equipmentError === false && categoryError === false && varietyError === false && treatmentTypeError === false && nbGroupesError === false && descriptionError === false && distanceError === false) ? (
                                    <p className='form-error'>Le traitement existe déjà ou n'a pas pu être enregistré !</p>
                                ) : (
                                    null
                                )}  
                                <form onSubmit={handleSubmit} className='flex-column'>
                                    <div className='flex-column form-center'>
                                        <InputForm error={nameError} type="text" label="Nom" value={name} setValue={setName} disabled={true}/>
                                        <SelectForm error={categoryError} labelText='Catégorie' choices={categories.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedCat} setSelectedItem={setSelectedCat}/>
                                        <SelectForm error={varietyError} labelText='Variété' choices={filteredVarieties.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedVar} setSelectedItem={setSelectedVar}/>
                                        <SelectForm error={targetTypeError} labelText='Type de cible' choices={targetTypes.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedTargetType} setSelectedItem={setSelectedTargetType}/>
                                        <SelectForm error={treatmentTypeError} labelText='Type de traitement' choices={treatmentTypes.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedTreatmentType} setSelectedItem={setSelectedTreatmentType}/>
                                        <InputForm error={distanceError} type="number" label="Distance" value={distance} setValue={setDistance} disabled={false}/>
                                        <InputForm error={descriptionError} type="text" label="Description" value={description} setValue={setDescription} disabled={false}/>
                                        <div></div>               
                                    </div>
                                    {/*Liste moduleParams*/}
                                    <div className='margin-top justify-center'>
                                        <div className='grid-1-1-1'>
                                            <div/>
                                            <div className='link'>
                                                {equipment['product']['name'] !== 'Boxistick' ? (
                                                    <h3 className='table-cell table-label'>Paramètres des PTUs </h3>
                                                ) : (
                                                    <h3 className='table-cell table-label'>Paramètres du PTU </h3>
                                                )}
                                                {(moduleParams.length < ptus.length) ? (
                                                    <img src={AddIcon} alt='add_item_icon' onClick={handleClickTreatmentParamAdd} className='link-img link-icon' />
                                                ) : (
                                                    <div/>
                                                )}
                                            </div>
                                            <div/>
                                        </div>
                                    </div>
                                    <div className='flex-column form-center margin-bottom '>
                                        <TableContainer sx={{ maxWidth: 900 }} component={Paper}>
                                            <TableMui size="small" aria-label="a dense table">
                                                <TableHead>
                                                <TableRow>
                                                    <TableCell><h3 className='table-label'>PTU</h3></TableCell>
                                                    <TableCell><h3 className='table-label'>Fréquence (Hz)</h3></TableCell>
                                                    <TableCell><h3 className='table-label'>Rapport cyclique (%)</h3></TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {(treatmentParamAdd === true) ? (
                                                    <TableRow key={0} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell component="th" scope="row">
                                                            <label className='select-form-tr'>
                                                                <p className='form-input'>PTU {moduleParams.length + 1}</p>
                                                            </label>
                                                        </TableCell>
                                                        <TableCell><input className='form-input' type='number' value={newFrequence} onChange={(e) => setNewFrequence(e.target.value)}/></TableCell>
                                                        <TableCell><input className='form-input' type='number' value={newPulseWidth} onChange={(e) => setNewPulseWidth(e.target.value)}/></TableCell>
                                                        <TableCell><button onClick={handleSubmitPtu} className='button'>Valider</button></TableCell>
                                                    </TableRow>
                                                ) : (
                                                    null
                                                )}
                                                {(moduleParams && moduleParams.length !== 0) ? (
                                                    moduleParams.map((moduleParam) => (
                                                        <TableRow key={moduleParam["ptu"]} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell component="th" scope="row">PTU {moduleParam["ptu"]}</TableCell>
                                                            <TableCell>{moduleParam["frequence"]}</TableCell>
                                                            <TableCell>{moduleParam["pulse_width"]}</TableCell>
                                                            <TableCell></TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <div><p className='table-cell-margin'>Aucun PTU actuellement. Veuillez en ajouter !</p></div>
                                                )}
                                                </TableBody>
                                            </TableMui>
                                        </TableContainer>
                                    </div>
                                    {/*Quarts des modules à allumer*/}
                                    {equipment['product']['name'] === 'Boxitunnel' ? (
                                        <div>
                                            <div className='flex-column justify-center'>
                                                <div className='grid-1-1-1'>
                                                    <div/>
                                                    <h3 className='table-cell table-label link'>Sélection des quarts de LEDS </h3>
                                                    <div/>
                                                </div>
                                            </div>
                                            <div className='flex-column form-center'>
                                                <div className='flex-row'>
                                                    <p>Quart 1 : </p>
                                                    <Checkbox sx={{'&.Mui-checked': {color: '#86c7a9'}}} checked={quart1} onChange={handleChangeQuart1} inputProps={{ 'aria-label': 'controlled' }}/> 
                                                    <p>Quart 2 : </p>
                                                    <Checkbox sx={{'&.Mui-checked': {color: '#86c7a9'}}} checked={quart2} onChange={handleChangeQuart2} inputProps={{ 'aria-label': 'controlled' }}/>
                                                    <p>Quart 3 : </p>
                                                    <Checkbox sx={{'&.Mui-checked': {color: '#86c7a9'}}} checked={quart3} onChange={handleChangeQuart3} inputProps={{ 'aria-label': 'controlled' }}/>
                                                    <p>Quart 4 : </p>
                                                    <Checkbox sx={{'&.Mui-checked': {color: '#86c7a9'}}} checked={quart4} onChange={handleChangeQuart4} inputProps={{ 'aria-label': 'controlled' }}/>              
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        null
                                    )}
                                    {/*Bouton valiser*/}
                                    <div className='flex-column form-right'>
                                        <button type="submit" className='button'>Valider</button>
                                    </div>
                                </form> 
                            </div>
                        ) : (
                            <div>
                                <p>Traitement non disponible !</p>
                                {/*Liens*/}
                                <div className='flex-row justify-center margin-bottom margin-top'>
                                    <div className='link-border'>
                                        <BackPage path={'/treatment-params/' + equipmentId}>Retour à la liste des traitements disponibles</BackPage>
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                </Container>
            </div>
        </div>
    );
}

export default TreatmentParamNew;
